import * as React from 'react';
import MyIcon from './Icon';
import ButtonGroup from '../ButtonGroup';
import { Tooltip } from 'antd';
const css = require('./index.scss');

export interface IIconProps {
    menuItem: any[]; // 显示的筛选条件
    limit?: number; // 超出多少条menu后出现省略号 默认三条
    trigger?: ('click' | 'hover' | 'contextMenu')[]; // 省略号出现menu的方式 默认click
    deleteFn: (item?: any, index?: number) => void; // 删除筛选条件的回调函数
    screenTextClassName?: any; // 筛选条件item的样式
    classNameClose?: any; // 垃圾桶样式
    isTooltip?: boolean; // 文字提示 默认 true
    isShowAllDelete?: boolean; // 是否显示全部删除按钮  默认 false 不显示
}

export default function SearchGroup(props: IIconProps) {
    const classNameScreenText = () => {
        return props.screenTextClassName ? `${css.screenText} ${props.screenTextClassName}` : css.screenText;
    };
    const classNameClose = () => {
        return props.classNameClose ? `${css.closeBox} ${props.classNameClose}` : css.closeBox;
    };
    const menuItem = () => {
        let menu = [];
        props.menuItem && 
        props.menuItem.length &&
        props.menuItem.map((item, index)=>{
            menu.push(
                (
                    <div className={css.screenItem} key={index} >
                        {
                            props.isTooltip === true ?
                            <Tooltip title={`${item.name}:${item.value}`}>
                                <div className={classNameScreenText()}>{`${item.name}:${item.value}`}</div>
                            </Tooltip> :
                            <div className={classNameScreenText()}>{`${item.name}:${item.value}`}</div>
                        }
                        <div className={css.closeBox} onClick={() => props.deleteFn(item,index)}>
                            <MyIcon className={css.closeIcon} src={require('./Icon/close.svg')}/>
                        </div>
                    </div>
                )
            );
        });
        return menu;
    };
    const limit = props.limit || 3;
    return (
        <div className={css.screenList}>
            {
                menuItem().slice(0,limit).map((item) => {
                    return item;
                })
            }
            <div className={css.spotRoot}>
                {
                    menuItem().length > limit &&
                    <ButtonGroup trigger={props.trigger} menuItem={menuItem().slice(limit,menuItem().length)} spotIcon={css.spotIcon} spotBox={css.spotBox} layout="row" placement="bottomLeft"/>
                }
            </div>
            {
                (menuItem().length > 0 && props.isShowAllDelete === true) && 
                <div className={classNameClose()} onClick={() => props.deleteFn()}>
                    <MyIcon className={css.deleteIcon} src={require('./Icon/delete.svg')}/>
                </div>
            }
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/display/components/ScreenList/index.tsx